module.exports = __webpack_public_path__ + "static/media/facebook_header.a21bb75c.svg";